var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreAction = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.94922,
  y: 19,
  width: 18,
  height: 18,
  rx: 9,
  transform: "rotate(-90 1.94922 19)",
  stroke: "#6B5CE8",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.49684 11C6.28964 11 6.08709 10.9386 5.91481 10.8234C5.74253 10.7083 5.60826 10.5447 5.52896 10.3533C5.44967 10.1619 5.42893 9.95122 5.46935 9.748C5.50977 9.54478 5.60955 9.35811 5.75606 9.2116C5.90257 9.06509 6.08924 8.96531 6.29246 8.92489C6.49568 8.88447 6.70632 8.90521 6.89774 8.98451C7.08917 9.0638 7.25279 9.19807 7.3679 9.37035C7.48302 9.54263 7.54446 9.74518 7.54446 9.95238C7.54446 10.2302 7.43408 10.4967 7.23762 10.6932C7.04115 10.8896 6.77468 11 6.49684 11ZM9.9016 9.95238C9.9016 10.1596 9.96304 10.3621 10.0782 10.5344C10.1933 10.7067 10.3569 10.841 10.5483 10.9203C10.7397 10.9995 10.9504 11.0203 11.1536 10.9799C11.3568 10.9394 11.5435 10.8397 11.69 10.6932C11.8365 10.5466 11.9363 10.36 11.9767 10.1568C12.0171 9.95354 11.9964 9.7429 11.9171 9.55147C11.8378 9.36005 11.7035 9.19643 11.5312 9.08132C11.359 8.9662 11.1564 8.90476 10.9492 8.90476C10.6714 8.90476 10.4049 9.01514 10.2084 9.2116C10.012 9.40807 9.9016 9.67453 9.9016 9.95238ZM14.354 9.95238C14.354 10.1596 14.4154 10.3621 14.5305 10.5344C14.6456 10.7067 14.8093 10.841 15.0007 10.9203C15.1921 10.9995 15.4028 11.0203 15.606 10.9799C15.8092 10.9394 15.9959 10.8397 16.1424 10.6932C16.2889 10.5466 16.3887 10.36 16.4291 10.1568C16.4695 9.95354 16.4488 9.7429 16.3695 9.55147C16.2902 9.36005 16.1559 9.19643 15.9836 9.08132C15.8113 8.9662 15.6088 8.90476 15.4016 8.90476C15.1238 8.90476 14.8573 9.01514 14.6608 9.2116C14.4644 9.40807 14.354 9.67453 14.354 9.95238Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreAction);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moreAction.f27714f9252bb5bf560e686c838c8063.svg";